export const SEARCH_AND_MONITORING_CONFIG_KEY =
   'SEARCH_AND_MONITORING_CONFIG_KEY'
